/* eslint-disable max-len */
import getData from 'sfcookieconsent/src/functions/getData';

export default {
    translationInfo: 'de_de',
    translationName: 'Deutsch',
    enableSFCookieConsent: true,
    headlineText: 'Diese Website verwendet Cookies',
    sublineText: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend zu verbessern, verwenden wir Cookies.',
    submitButtonText: 'Auswahl bestätigen',
    submitAllButtonText: 'Alle auswählen',
    escButtonText: 'Abbrechen',
    consentTypes: {
        marketing: {
            label: 'Marketing',
            title: 'Marketing Cookies',
            text: 'Marketing Cookies werden von Drittanbietern oder Publishern verwendet, um personalisierte Werbung anzuzeigen. Sie folgen Besuchern auf Websiten, um Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind.',
        },
        necessary: {
            label: 'Notwendig',
            title: 'Notwendige Cookies',
            text: 'Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.',
        },
        preferences: {
            label: 'Präferenzen',
            title: 'Präferenz Cookies',
            text: 'Präferenz Cookies ermöglichen einer Webseite sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie sich befinden.',
        },
        statistics: {
            label: 'Statistiken',
            title: 'Statistik Cookies',
            text: 'Statistik-Cookies helfen Webseiten-Besitzer*innen zu verstehen, wie Besucher*innen mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
        },
    },
    showDetailsText: 'Details anzeigen',
    hideDetailsText: 'Details ausblenden',
    moreInfoPreText: 'Weitere Informationen zu Cookies finden Sie in unserer',
    moreInfoLinkText: '<span class="underline">Datenschutzerklärung</span> und <a href="/de/cookie-hinweis" class="main-header main-header--overlaying"><span class="underline">Cookie-Richtlinie</span></a>',
    moreInfoLinkHref: '/de/hinweise-zum-datenschutz',

    detailContainer: 'Wir nutzen Cookies, um Ihnen die bestmögliche Nutzung unserer Webseite zu ermöglichen und unsere Kommunikation mit Ihnen zu verbessern. Treffen Sie hier Ihre persönliche Präferenz:',
    scriptSettings: {
        statistics: {
            gtm: {
                enabled: true,
                key: getData('header', 'data-sfcc-gtm-key'),
                authKey: getData('header', 'data-sfcc-gtm-auth'),
                preview: getData('header', 'data-sfcc-gtm-preview'),
                gtm_cookies_win: getData('header', 'data-gtm_cookies_win'),
            },
        },
    },
};
